import { Invoice } from '@/classes/case/Invoice'
import invoiceApi from '@/api/customer/invoiceApi'
import FormData from '@/classes/form/FormData'
import FormDescriptor from '@/classes/form/FormDescriptor'
import { findItem, getFilter } from '@/store/utility_functions'

const state = {
  invoices: [],
  invoiceFormDescriptors: [],
  invoiceFormDatas: [],
  articleFormDescriptors: [],
  articleFormDatas: [],
  articleNumberFormDescriptors: [],
  articleNumberFormDatas: [],
  addedFormDescriptors: [],
  addedFormDatas: []
}

const mutations = {
  setStateInvoices: (state, invoices) => {
    state.invoices = invoices
  },
  addToStateInvoice: (state, invoice) => {
    state.invoices.push(invoice)
  },
  updateStateInvoice: (state, data) => {
    data.current.updateCurrentInvoice(data.updated)
  },
  setStateArticleFormDescriptors: (state, data) => {
    state.articleFormDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setStateArticleFormDatas: (state, data) => {
    state.articleFormDatas = FormData.initiateFormDatas(state.articleFormDescriptors)
    FormData.loadInitialFormDatasWithIndex(data, state.articleFormDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.articleFormDescriptors, state.articleFormDatas)
  },
  setStateInvoiceFormDescriptors: (state, data) => {
    state.invoiceFormDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setStateInvoiceFormDatas: (state, data) => {
    state.invoiceFormDatas = FormData.initiateFormDatas(state.invoiceFormDescriptors)
    FormData.loadInitialFormDatas(data, state.invoiceFormDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.invoiceFormDescriptors, state.invoiceFormDatas)
  },
  setStateArticleNumberFormDescriptors: (state, data) => {
    state.articleNumberFormDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setStateArticleNumberFormDatas: (state, data) => {
    state.articleNumberFormDatas = FormData.initiateFormDatas(state.articleNumberFormDescriptors)
    FormData.loadInitialFormDatas(data, state.articleNumberFormDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.articleNumberFormDescriptors, state.articleNumberFormDatas)
  },
  setAddedFormDescriptors: (state, data) => {
    state.addedFormDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setAddedFormDatas: (state, data) => {
    state.addedFormDatas = FormData.initiateFormDatas(state.addedFormDescriptors)
    FormData.loadInitialFormDatas(data, state.addedFormDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.addedFormDescriptors, state.addedFormDatas)
  },
  extendFormDescriptorsFieldSetsAndData: (state, form) => {
    let index = form.descriptor.fieldSets.length
    // update keys and add form field sets
    for (let field of state.addedFormDescriptors[0].fieldSets[0].fields) {
      field.id = field.id.replace('#0', '#' + index)
    }
    form.descriptor.fieldSets = form.descriptor.fieldSets.concat(state.addedFormDescriptors[0].fieldSets)
    // update keys and add form datas
    for (let key in state.addedFormDatas[0].fields) {
      let nkey = key.replace('#0', '#' + index)
      form.data.fields[nkey] = state.addedFormDatas[0].fields[key]
      form.data.fields[nkey].dataSubGroup = index
      form.data.validations[nkey] = state.addedFormDatas[0].validations[key]
    }
  }
}

const actions = {
  getInvoices ({ commit }, request) {
    let filter = getFilter(request)
    return invoiceApi.getInvoices(filter).then((response) => {
      let invoices = Invoice.asInvoices(response.data.results)
      commit('setStateInvoices', invoices)
      return response.data
    }).catch((err) => {
      throw err
    })
  },
  updateInvoice ({ commit, state }, invoice) {
    let existing = findItem(state.invoices, invoice.id)
    if (existing) {
      commit('updateStateInvoice', {
        current: existing,
        updated: invoice
      })
    } else {
      commit('addToStateInvoice', invoice)
    }
  },
  setInvoice ({ dispatch }, invoiceId) {
    return invoiceApi.getInvoice(invoiceId).then((response) => {
      let invoice = Invoice.asInvoice(response.data)
      dispatch('updateInvoice', invoice)
      return invoice
    }).catch((err) => {
      throw err
    })
  },
/*   setInvoice ({ commit }, invoiceId) {
    return invoiceApi.getInvoice(invoiceId).then((response) => {
      let invoice = Invoice.asInvoice(response.data)
      commit('addToStateInvoice', invoice)
      return invoice
    }).catch((err) => {
      throw err
    })
  },
  refreshInvoice ({ commit }, invoice) {
    return invoiceApi.getInvoice(invoice.id).then((response) => {
      commit('updateStateInvoice', {
        current: invoice,
        updated: Invoice.asInvoice(response.data)
      })
    }).catch((err) => {
      throw err
    })
  }, */
  setupInvoiceCreateFormForCustomer ({ commit, state }, customerId) {
    return invoiceApi.getInvoiceCreateFormForCustomer(customerId).then((response) => {
      let formData = response.data.form_data ? [response.data.form_data] : []
      commit('setStateInvoiceFormDescriptors', [response.data])
      commit('setStateInvoiceFormDatas', formData)
    }).catch((err) => {
      throw err
    })
  },
  setupInvoiceCreateFormForCase ({ commit, state }, caseId) {
    return invoiceApi.getInvoiceCreateFormForCase(caseId).then((response) => {
      commit('setStateInvoiceFormDescriptors', [response.data])
      commit('setStateInvoiceFormDatas', [response.data.form_data])
    }).catch((err) => {
      throw err
    })
  },
  initializeArticleForms ({ commit, state }, response) {
    let formDescriptors = response && response.data ? [response.data] : []
    let formData = response && response.data ? [response.data.form_data] : []
    commit('setStateArticleFormDescriptors', formDescriptors)
    commit('setStateArticleFormDatas', formData)
  },
  setupInvoiceForm ({ commit, state }, invoiceId) {
    return invoiceApi.setupInvoiceForm(invoiceId).then((response) => {
      commit('setStateInvoiceFormDescriptors', [response.data])
      commit('setStateInvoiceFormDatas', [response.data.form_data])
    }).catch((err) => {
      throw err
    })
  },
  setupArticlesListCreateForm ({ dispatch }, caseId) {
    return invoiceApi.setupArticlesListFormForCase(caseId).then((response) => {
      // initializes a new form
      FormDescriptor.initiateTemplateFieldSets(response.data, response.data.form_data)
      dispatch('initializeArticleForms', response)
    }).catch((err) => {
      throw err
    })
  },
  setupArticlesListEditForm ({ dispatch }, invoiceId) {
    return invoiceApi.getArticlesListEditForm(invoiceId).then((response) => {
      // initializes a new form
      FormDescriptor.initiateTemplateFieldSets(response.data, response.data.form_data)
      dispatch('initializeArticleForms', response)
    }).catch((err) => {
      throw err
    })
  },
  setupArticlesListFormForCase ({ commit, state }, caseId) {
    return invoiceApi.setupArticlesListFormForCase(caseId).then((response) => {
      // adds to an already existing form
      for (let data of response.data.form_data) {
        commit('setAddedFormDescriptors', [response.data])
        commit('setAddedFormDatas', [[data]])
        if (state.articleFormDescriptors.length) {
          commit('extendFormDescriptorsFieldSetsAndData',
            { descriptor: state.articleFormDescriptors[0], data: state.articleFormDatas[0] })
        }
      }
    }).catch((err) => {
      throw err
    })
  },
  setupArticleAddForm ({ commit, state }) {
    return invoiceApi.setupArticleAddForm().then((response) => {
      commit('setStateArticleNumberFormDescriptors', [response.data])
      commit('setStateArticleNumberFormDatas', [])
    }).catch((err) => {
      throw err
    })
  },
  setupArticleRowForm ({ commit, state, dispatch }, articleNumber) {
    return invoiceApi.setupArticleRowForm(articleNumber).then((response) => {
      commit('setAddedFormDescriptors', [response.data])
      commit('setAddedFormDatas', [response.data.form_data])
      if (state.articleFormDescriptors.length) {
        commit('extendFormDescriptorsFieldSetsAndData',
          { descriptor: state.articleFormDescriptors[0], data: state.articleFormDatas[0] })
        return
      }
      dispatch('initializeArticleForms', response)
    }).catch((err) => {
      throw err
    })
  },
  setupInvoiceEditForm ({ commit, state }, invoiceId) {
    return invoiceApi.getInvoiceEditForm(invoiceId).then((response) => {
      FormDescriptor.initiateTemplateFieldSets(response.field_sets, response.form_data)
      commit('setStateInvoiceFormDescriptors', [response.data])
      commit('setStateInvoiceFormDatas', [response.data.form_data])
    }).catch((err) => {
      throw err
    })
  },
  postInvoiceCreateForm ({ commit }, requestData) {
    return invoiceApi.postInvoiceCreateForm(requestData.data.caseId, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  postInvoiceCreateFormForCustomer ({ commit }, requestData) {
    return invoiceApi.postInvoiceCreateFormForCustomer(requestData.data.customerId, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  putInvoiceEditForm ({ commit }, requestData) {
    return invoiceApi.putInvoiceEditForm(requestData.data.invoiceId, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  putInvoiceArticleEditForm ({ commit }, requestData) {
    return invoiceApi.putInvoiceArticleEditForm(requestData.data.invoiceId, requestData.serializedData, requestData.data.caseIds).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  postConfirmInvoice ({ commit, dispatch }, invoiceId) {
    return invoiceApi.postConfirmInvoice(invoiceId).then((response) => {
      let invoice = Invoice.asInvoice(response.data)
      dispatch('updateInvoice', invoice)
      return invoice
    }).catch((err) => {
      throw err
    })
  },
  postCancelInvoice ({ commit, dispatch }, invoiceId) {
    return invoiceApi.postCancelInvoice(invoiceId).then((response) => {
      let invoice = Invoice.asInvoice(response.data)
      dispatch('updateInvoice', invoice)
      return invoice
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
